import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatCount } from "@/lib/safeData";
import { Eye } from "lucide-react";

const ViewerCount = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchCount = async () => {
      try {
        const res = await api.get("/viewer-count");
        if (mounted) setCount(res.data.count);
      } catch {
        if (mounted) setCount(null);
      }
    };
    fetchCount();
    const id = setInterval(fetchCount, 30000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  if (count === null || count === undefined) return null;
  const n = Number(count);
  if (!Number.isFinite(n) || n < 1) return null;

  return (
    <div
      className="w-full bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37]/20 to-[#D4AF37]/10 border-b border-[#D4AF37]/30 text-[11px] sm:text-xs"
      data-testid="viewer-count-bar"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-1.5 flex items-center justify-center gap-2 text-white/85 font-mono-alt">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#34D399] opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#34D399]" />
        </span>
        <Eye className="h-3 w-3 text-[#D4AF37]" />
        <span data-testid="viewer-count-value">
          <span className="font-bold text-[#D4AF37]">{formatCount(n)}</span>
          <span className="text-white/70"> people protecting themselves on CHINTAMAT right now</span>
        </span>
      </div>
    </div>
  );
};

export default ViewerCount;
